import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const ChangePasswordModal = ({ targetUser, onClose }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  // Reset fields whenever the modal opens for a new target.
  useEffect(() => {
    if (targetUser) {
      setNewPassword('');
      setConfirmPassword('');
      setError('');
    }
  }, [targetUser]);

  const handleOk = () => {
    setError('');

    if (!newPassword || !confirmPassword) {
      setError('Both password fields are required.');
      return;
    }
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    const fullName = `${targetUser.firstName} ${targetUser.lastName}`.trim();
    if (!window.confirm(`Are you sure you want to change, ${fullName}'s password?`)) {
      return;
    }

    // Backend endpoint not yet available — see Documentation journal Section 5
    // (frontend) and the Path A note. Wire to PUT /users/changePassword/:id
    // once shipped on the backend.
    window.alert(
      'Change-password backend endpoint is not yet available. ' +
        'This action will be enabled once the API is deployed.'
    );
  };

  const open = !!targetUser;

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {targetUser && (
          <p className="text-muted mb-3">
            Setting a new password for{' '}
            <strong>
              {targetUser.firstName} {targetUser.lastName}
            </strong>{' '}
            ({targetUser.email}).
          </p>
        )}

        {error && (
          <Alert variant="danger" onClose={() => setError('')} dismissible>
            {error}
          </Alert>
        )}

        <Form onSubmit={(e) => { e.preventDefault(); handleOk(); }}>
          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoFocus
            />
            <Form.Text className="text-muted">
              Minimum 8 characters.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Re-enter New Password</Form.Label>
            <Form.Control
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleOk}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;
